<div class="{{ iconClass }}"></div>
<span class="message">{{ message }}</span>
<span class="text" *ngIf="text">{{ text }}</span>
